import React, { useState, useEffect } from "react";
import { Col } from "react-materialize";
import { useForm } from "react-hook-form";

import { withTranslation } from 'react-i18next';
import { compose } from "redux";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import ButtonFactory from "../../../components/material/ButtonFactory";
import userApi from "../../../api/userApi";
import plantApi from "../../../api/plantApi";
import { ROLES_AVAILABLE } from "../../../utils/roleHelper";

function CreateUser(props) {
  const { t } = props;
  const roles = ROLES_AVAILABLE
  const [plants, setPlants] = useState([]);
  const [activePlant, setActivePlant] = useState([]);
  const [isActive, setIsActive] = useState(props.user.isActive);
  const { register, handleSubmit, formState: { errors } } = useForm(
    {
        defaultValues: {
            name: props.user.name,
            email: props.user.email,
            company: props.user.company,
            userRole: props.user.role,
            plant: props.user.plant || ''
        }
    }
  )

  useEffect(() => {
    let isMounted = true;
    plantApi.getPlants()
    .then(res => {
      if (isMounted) {
        setPlants(res.data);
        setActivePlant(res.data.find(plant => plant.id === props.user.plant));
      }
    })
    .catch(
    );
    return () => {
      isMounted = false;
    }
  }, [plants, props]);

  function cancelButton(e) {
    props.onClose(e);
  }

  function onSubmit(data) {
    const userData = {
          name : data.name,
          email: data.email,
          company: data.company,
          role: data.userRole,
          isAdmin: data.userRole === "Admin",
          isActive: isActive,
          plant: data.plant
    };

    userApi.editUser(userData, props.userId)
      .then( res => {
        props.onClose();
      })
      .catch(err => {
        throw err
    });
  }

    function handleInputChange(e) {
        setIsActive(!isActive);
    };

    return(
      <div id="addUser" style={{  maxHeight: "95%", position:"fixed", width:"550px", backgroundColor:"#e6e6e6",borderRadius:"7px",paddingTop:"0px", marginTop:"-95px", marginLeft:" calc(50% - 730px)", zIndex:"999",overflowY:"scroll" }} className="container center-align"   >
       <Col s={12} >
        <h3 className="center-align defaultTheme white-text" >
          {t('setting.user_add')}
        </h3>
       </Col>
       <form onSubmit={handleSubmit(onSubmit)} name="userForm" id="userForm">
       <Col m={4} s={12}>
          <label className="active" htmlFor="name" style={{ width: "300px", display: "inline-block" }} >{t('input.name')}</label>
          <input type="text" name="name" {...register("name", { required:  t('input.name_required'), pattern: {value: /^.{2,30}$/, message: t('input.name_invalid')} })} className=" center-align " style={{ backgroundColor: "#ffffff", borderRadius: "7px", marginLeft: "10%", marginRight: "10%", width: "75%" }} />
          {errors.name && <p className="red-text" >{errors.name.message}</p>}
        </Col>
        <Col m={4} s={12}>
          <label className="active" htmlFor="email" style={{ width: "300px", display: "inline-block" }} >{t('input.email')}</label>
          <input type="text" name="email" {...register('email', {required: t('input.email_required'), pattern: {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: t('input.email_invalid')}})} className=" center-align " style={{ backgroundColor: "#ffffff", borderRadius: "7px", marginLeft: "10%", marginRight: "10%", width: "75%" }} />
          {errors.email && <p className="red-text" >{errors.email.message}</p>}
        </Col>
        <Col m={4} s={12}>
          <label className="active" htmlFor="company" style={{ width: "300px", display: "inline-block" }} >{t('input.company')}</label>
          <input type="text" name="company" {...register('company', {required: t('input.company_required'), pattern: {value: /^.{2,30}$/, message: t('input.company_invalid')}})} className=" center-align " style={{ backgroundColor: "#ffffff", borderRadius: "7px", marginLeft: "10%", marginRight: "10%", width: "75%" }} />
          {errors.company && <p className="red-text" >{errors.company.message}</p>}
        </Col>
        <Col m={4} s={12}>
          <label className="active" htmlFor="userRole" style={{ width: "300px", display: "inline-block" }} >{t('setting.user_role')}</label>
          <select name="userRole" {...register('userRole')} className=" center-align " style={{ backgroundColor:"#ffffff", borderRadius: "7px", marginLeft: "12.5%", marginRight: "12.5%", marginBottom: "5px", width: "75%" }}>
            {roles.map(role => (
                <option key={role} value={role}>{role}</option>
            ))}
          </select>
          {errors.userRole && <p className="red-text" >{errors.userRole.message}</p>}
        </Col>
        <Col m={4} s={12}>
          <label className="active" htmlFor="plant" style={{ width: "300px", display: "inline-block" }} >{t('plant.plant')}</label>
          <select name="plant" {...register('plant' , {validate: value => value !== '' || t('plant.plant_required')})} className=" center-align " style={{ backgroundColor:"#ffffff", borderRadius: "7px", marginLeft: "12.5%", marginRight: "12.5%", marginBottom: "5px", width: "75%" }}>
            <option value={props.user.plant || ""} disabled hidden>{props.user.plant === undefined ? t('input.plant_select') : activePlant.name}</option>
            {plants.map(plant => (
                <option key={plant.id} value={plant.id}>{plant.name}</option>
            ))}
          </select>
          {errors.plant && <p className="red-text" >{errors.plant.message}</p>}
        </Col>
        <Col m={4} s={12}>
        <label className="active" htmlFor="isActive"  style={{ width: "300px", display: "inline-block" }} >{t('setting.active')}</label>
          <input type="checkbox" id="isActive" style={{backgroundColor: "#ffffff", opacity: "100", position: "relative", pointerEvents: "visible"}}  defaultChecked={isActive}  onClick={handleInputChange} />
        </Col>
         <hr/>
         <div className="row " style={{float:"right"}}>
          <ButtonFactory name='Submit' text={t('ok')} onClick={handleSubmit(onSubmit)} style={{marginRight:"35px"}}/>
          <ButtonFactory name='Cancel' text={t('cancel')} onClick={cancelButton} style={{marginRight:"15px"}}/>
        </div>
       </form>
      </div>
    );
}

CreateUser.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(CreateUser);
